import { Link } from "react-router-dom";
import { usePatientsBase } from "../../../utils/hubPaths";
import { Avatar } from "../../ui";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import { athletePortalAccessLabel } from "./patientConstants";
import aa from "../AdminPortal/adminApp.module.css";

function normalizeChildren(profile, sport) {
  const fromProfile = profile?.linked_athletes || [];
  const fromSport = sport?.children || [];
  const raw = fromProfile.length ? fromProfile : fromSport;
  return raw.map((child) => ({
    id: child.id,
    full_name: child.full_name,
    photo_url: child.photo_url,
    relation: child.relation,
    groups: child.groups || [],
    membership_label: child.membership_label,
    portal_login_email: child.portal_login_email,
    portal_activated: child.portal_activated,
    email: child.email,
  }));
}

function childPortalHint(child) {
  const label = athletePortalAccessLabel(child);
  return label === "нужен email" ? null : label;
}

function childMeta(child) {
  const groupNames = (child.groups || [])
    .map((g) => g.name || g)
    .filter(Boolean)
    .join(", ");
  return [child.membership_label, groupNames].filter(Boolean).join(" · ") || "Без группы";
}

export default function ClientChildrenStrip({ profile, sport }) {
  const patientsBase = usePatientsBase();
  const children = normalizeChildren(profile, sport);
  if (!children.length) return null;

  const preview = children
    .slice(0, 2)
    .map((c) => c.full_name)
    .join(", ");

  return (
    <section className={aa.clientChildrenStrip} aria-label="Дети в клубе">
      <div className={aa.clientChildrenStripHead}>
        <span className={aa.clientChildrenStripLabel}>
          {children.length === 1 ? "Ребёнок в клубе" : `Дети в клубе · ${children.length}`}
        </span>
        <Link to={`${patientsBase}?add=1`} className={aa.clientChildrenStripAdd}>
          + Ребёнок
        </Link>
      </div>
      <ul className={aa.clientChildrenStripList}>
        {children.map((child) => {
          const portalHint = childPortalHint(child);
          return (
          <li key={child.id}>
            <Link to={`${patientsBase}/${child.id}`} className={aa.clientChildrenStripCard}>
              <Avatar
                name={child.full_name}
                src={mediaUrl(child.photo_url)}
                size="sm"
              />
              <span className={aa.clientChildrenStripCardBody}>
                <strong>{child.full_name}</strong>
                <span>{childMeta(child)}</span>
                {portalHint ? <small>Кабинет: {portalHint}</small> : null}
                {child.relation ? <small>{child.relation}</small> : null}
              </span>
            </Link>
          </li>
          );
        })}
      </ul>
      {children.length > 2 ? (
        <p className={aa.clientChildrenStripFoot}>{preview} и ещё {children.length - 2}</p>
      ) : null}
    </section>
  );
}
